<template>

<div class="section-container">

  <BgVideo
    id="slide01"
    name="cover.mp4"/>

  <div id="slide01" class="section">

    <div class="logo">
      <Fimage name="logo.svg"/>
    </div>

    <div class="cover">

      <Title :text="$t('home.slide01.title')"/>

      <div class="cover-text">
        <SmallCommon :text="$t('home.slide01.text')"/>
      </div>

      <div class="chart-block">
        <Fimage name="slide01.png"/>
      </div>

      <ul>

        <li>{{ $t('home.slide01.technologies.tech01') }}</li>

        <li>{{ $t('home.slide01.technologies.tech02') }}</li>

        <li>{{ $t('home.slide01.technologies.tech03') }}</li>

        <li>{{ $t('home.slide01.technologies.tech04') }}</li>

        <li>{{ $t('home.slide01.technologies.tech05') }}</li>

        <li>{{ $t('home.slide01.technologies.tech06') }}</li>

        <li>{{ $t('home.slide01.technologies.tech07') }}</li>

        <li>{{ $t('home.slide01.technologies.tech08') }}</li>

        <li>{{ $t('home.slide01.technologies.tech09') }}</li>

        <li>{{ $t('home.slide01.technologies.tech10') }}</li>

        <li>{{ $t('home.slide01.technologies.tech11') }}</li>

        <li>{{ $t('home.slide01.technologies.tech12') }}</li>

        <li>{{ $t('home.slide01.technologies.tech13') }}</li>

      </ul>

    </div>

    <Arrow
      type="down"
      toType="page"
      toId="#slide02"
      :text="$t('home.slide01.arrow')"/>

  </div>

</div>

</template>

<script>
import Title from '../general/texts/Title.vue'
import SmallCommon from '../general/texts/SmallCommon.vue'
import BgVideo from '../general/elements/BgVideo.vue'
import Fimage from '../general/elements/Fimage.vue'
import Arrow from '../general/elements/Arrow.vue'

export default {
  name: 'Slide01',
  components: {
    Title,
    SmallCommon,
    BgVideo,
    Fimage,
    Arrow
  }
}
</script>

<style lang="scss" scoped>
.section {
  width: 90% !important;
  text-align: center !important;

  p {
    text-align: center !important;
  }

  .logo {
    padding: 50px 0;
  }

  .cover {
    margin: 150px 0;

    .cover-text {
      width: 60%;
      margin: auto;
    }

    .chart-block {
      margin: 50px auto;

      img {
        width: 25%;
      }
    }

    ul {
      width: 50%;
      margin: auto;
      padding: 0;

      li {
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        display: inline-block;
        font-size: 18px;
        line-height: 1.67;
        list-style: none;
        border: solid 1px white;
        border-radius: 50px;
        padding: 10px 30px;
        margin: 10px;
      }
    }
  }
}

@media (max-width: 2250px), (max-device-width: 2250px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 30%;
        }
      }

      ul {
        width: 60%;
      }
    }
  }
}

@media (max-width: 1850px), (max-device-width: 1850px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 40%;
        }
      }

      ul {
        width: 80%;
      }
    }
  }
}

@media (max-width: 1630px), (max-device-width: 1630px) {
  .section {
    .cover {
      ul {
        width: 90%;
      }
    }
  }
}

@media (max-width: 1300px), (max-device-width: 1300px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 50%;
        }
      }

      ul {
        width: 100%;
      }
    }
  }
}

@media (max-width: 700px), (max-device-width: 700px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 60%;
        }
      }
    }
  }
}

@media (max-width: 550px), (max-device-width: 550px) {
  .section {
    .cover {
      margin: 50px 0 100px 0;

      .cover-text {
        width: 80%;
      }

      .chart-block {
        img {
          width: 70%;
        }
      }

      ul {
        li {
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 80%;
        }
      }
    }
  }
}

@media (max-width: 390px), (max-device-width: 390px) {
  .section {
    .cover {
      .chart-block {
        img {
          width: 90%;
        }
      }
    }
  }
}
</style>
